import React from "react";
const StationOverView = () => {
  return (
    <div className="papaDiv">
      <h6 className="bg-dark text-white p-1">Station wise cause</h6>
      <div></div>
    </div>
  );
};
export default StationOverView;
